export default __webpack_public_path__ + "static/media/272.d941f3ec.png";